import { ILabelProps, TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';

import { IUserClub } from '../../types';

const getOperatorFio = (
  firstName: string | undefined,
  lastName: string | undefined
): string => {
  if (!lastName) {
    return '';
  }

  let resultString = lastName;

  if (firstName) {
    resultString += ` ${firstName[0]}.`;
  }

  return resultString;
};

export const getWorkShiftLabelConfig = (
  { workShiftStatus, operatorFirstName, operatorLastName }: IUserClub,
  t: TTranslator<TLocalesKeys>
): ILabelProps => {
  if (workShiftStatus === 'MY') {
    return { color: 'green', text: t('workShifts.status.my') };
  }

  if (workShiftStatus === 'OPEN') {
    return {
      color: 'violet',
      text: t(
        'workShifts.status.onShift',
        getOperatorFio(operatorFirstName, operatorLastName)
      ),
    };
  }

  return { color: 'gray-primary', text: t('workShifts.status.no') };
};
